import { render, staticRenderFns } from "./SelfServiceCarWash.vue?vue&type=template&id=055c7788&scoped=true"
import script from "./SelfServiceCarWash.vue?vue&type=script&lang=js"
export * from "./SelfServiceCarWash.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceCarWash.vue?vue&type=style&index=0&id=055c7788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c7788",
  null
  
)

export default component.exports